import { Dayjs } from "dayjs"
import { Geometry } from "geojson"

export interface Geofence {
    _id: string
    geometry: Geometry // Replace `any` with the actual geometry type (e.g., GeoJSON type)
    properties: {
        entity: string
        entityId: string
        name: string
        type: string
    }
}
export interface IJobListQueryOutput {
    _id: string
    serial: string
    jobReference: string
    billable: {
        _id: string
        account: string
        company: string
    }
    destination: {
        _id: string
        account: string
        company: string
    }
    items: {
        _id: string
        itemId: string
        name: string
        code: string
        quantity: string
    }[]
    destinationAddress: {
        address: string
        _id: string
    }
    originAddress: {
        address: string
        _id: string
    }
    groupId: string | null
}

export enum EJobStatus {
    idle = "idle",
    onRouteToPickup = "onRouteToPickup",
    atPickupLocation = "atPickupLocation",
    loading = "loading",
    loaded = "loaded",
    onRouteToDelivery = "onRouteToDelivery",
    atDeliveryLocation = "atDeliveryLocation",
    unloading = "unloading",
    unloaded = "unloaded",
    onHold = "onHold",
    completed = "completed",
    canceled = "canceled",
}

export interface IJob {
    jobId: number
    jobReference: string
    jobDate: Date | string
    jobType: string
    items: IJobItems[]
    _id: string
    jobStatus: EJobStatus
    origin: {
        account: string
        company: string
        _id: string
    }
    originAddress: {
        address: string
        gps: {
            type: string
            coordinates: number[]
        }
        geofence: Geofence[]
        _id: string
    }
    billable: {
        account: string
        company: string
        _id: string
    }
    destination: {
        account: string
        company: string
        _id: string
    }
    destinationAddress: {
        address: string
        gps: {
            type: string
            coordinates: number[]
        }
        geofence: Geofence[]
        _id: string
    }
    groupId: string | null
    serial: string
    customFields: ICustomFieldTemplate[]
    assignedShift: {
        shiftId: string
        vehicle: string
    }
    number: string
    isJobCompleted: boolean
    type: string
}

export interface IJobListing extends IJob {
    type: string
}

export interface IStop {
    type: string
    jobId: string
    status: EJobStatus
}

interface IJobStopGroup {
    groupJob: boolean
    destinationStops: IStop[][]
}

export interface IShiftStopIds {
    [key: string]: IJobStopGroup
}

export interface IShiftJobs {
    [key: string]: { groupJob: boolean; destinationStops: IJobListing[][] }
}

export interface IJobItems {
    _id: string
    itemId: string
    name: string
    code: string
    quantity: string
    unit?: string
    pricePerItem: number
    kgPerUnit?: number
    quantityLoaded: string | null
    quantityUnloaded: string | null
}
export interface ICustomFieldTemplate {
    __typename: string
    customFieldGroup: {
        _id: string
        name: string
    }
    customFieldTemplateId: string
    name: string
    type: string
    value: string | boolean | Dayjs | null
    systemVisibility: string
    driverVisibility: string
    requiredStage: string
    enumeratedValues: any
}

export interface IJobDetail {
    "Job Id": string
    Reference: string
    Client: string
    Origin: string
    Destination: string
    "Job Status": string
}

export const stageTypes = Object.freeze({
    PICKUP: "pickup",
    DELIVERY: "delivery",
})
